import { Quotulator } from "../../quotulator"

export const QuotulatorFlowPage = () => {
  return(
    <Quotulator />
  )
}